module.exports = __webpack_public_path__ + "5d2c4319ad79ebef755309b9fc3b8c0a.fbx";